import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { Button } from "@profitlens/ui/button";

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="text-5xl font-semibold text-muted">404</p>
      <p className="text-sm text-muted">{t("errors.not_found")}</p>
      <Button asChild variant="outline">
        <Link to="/">{t("common.back")}</Link>
      </Button>
    </div>
  );
}
